export default "__VITE_ASSET__830b5736__"